/**
 * Accommodation Types Constants
 *
 * List of all accommodation types available in the system.
 * These correspond to the accommodation_types table in the database.
 */

export const ACCOMMODATION_TYPES = [
  { id: 1, name: "호텔" },
  { id: 2, name: "모텔" },
  { id: 3, name: "민박" },
  { id: 4, name: "게스트하우스" },
  { id: 5, name: "펜션" },
  { id: 6, name: "여인숙" },
  { id: 7, name: "산장" },
  { id: 8, name: "전통숙소" },
  { id: 9, name: "쉐어하우스" },
  { id: 10, name: "리조트" },
  { id: 11, name: "생활형숙박시설" },
  { id: 12, name: "기타숙박업" },
] as const;

export type AccommodationTypeId = (typeof ACCOMMODATION_TYPES)[number]["id"];
export type AccommodationTypeName = (typeof ACCOMMODATION_TYPES)[number]["name"];
